interface IResponse {
  code: number;
  message: string;
  ttl: number;
  // data: any;
}


/**
 * 关注/取关用户: /intl/gateway/web/v2/user/follow/modify,
 * http://bapi.bilibili.co/project/5885/interface/api/404596
 */
export interface IFollowRequest {
  fid: number; // 关注的人 mid
  action: number; // 1加关 2取关
  room_id?: number; // 所处的房间id
  spm_id?: string;
  from_spm_id?: string;
}

export interface IFollowResponse extends IResponse {

}

/**
 * 用户接口 v2 : /intl/gateway/web/v2/user
 * http://bapi.bilibili.co/project/5885/interface/api/410795
 */
export interface IUserRequest {

}

export interface IUserResponse extends IResponse {
  data: IUserResponseData
}

export interface IUserResponseData {
  is_login: boolean;
  mid: number;
  nickname: string; // 昵称
  avatar: string; // 头像
  sign: string; // 签名
}

export interface IBirth {
  date: string; // 生日日期
  toast: string; // 提示
}

export interface IVipInfo {
  is_vip: boolean; // 是否 vip
  due_date: string; // 到期时间
}

export enum AuthType {
  NickNameWithPassword = 1,
  PhoneWithPassword = 2,
  email = 3,
  phone = 8,
  TOSVisitor = 9,
  OneTap = 10,
  facebook = 13,
  google = 14,
  apple = 15,
  twitter = 16,
  qrcode = 17
}